import React, { Component } from 'react';
import PropTypes from "prop-types"
import { Link } from "gatsby"
import {
  BrowserView,
  MobileView,
  isMobile
} from "react-device-detect";
import select from '../components/utils'


class Nav extends Component {
  componentDidMount() {

   const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
    // Check if there are any navbar burgers
   if ($navbarBurgers.length > 0) {

     // Add a click event on each of them
     $navbarBurgers.forEach( el => {
       el.addEventListener('click', () => {

         // Get the target from the "data-target" attribute
         const target = el.dataset.target;
         const $target = document.getElementById(target);
         // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
         el.classList.toggle('is-active');
         $target.classList.toggle('is-active');

       });
     });
   }

   // Get all "navbar-link" elements
  const navbarLink = Array.prototype.slice.call(document.querySelectorAll('.navbar-link'), 0);
   // Check if there are any navbar links
  if (navbarLink.length > 0) {

    // Add a click event on each of them
    navbarLink.forEach( el => {
      el.addEventListener('click', () => {
        el.nextElementSibling.classList.toggle('is-hidden-mobile');
      });
    });
  }

}

      render() {
       const props = this.props;
       const sel = select(props.langKey);

        return (
    <div>
    <section className="hero is-primary">
    <div className="xhero-body xcontainer">
    <nav className="navbar" role="navigation" aria-label="main navigation">
    <div className="container">
      <div className="navbar-brand">
        <a role="button" className="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarMonitaur">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarMonitaur" className="navbar-menu">
        <div className="navbar-start">
         <div className="navbar-item">
          <a id="ctgca" className="navbar-item">
            <Link to="/" id="ctgc" className="navbar-item">Home</Link>
          </a>
         </div>
        </div>

        <div className="navbar-end">
          <div className="navbar-item">
              <a id="ctgca" className="navbar-item">
                <Link to="/chart" id="ctgc" className="navbar-item">Chart</Link>
              </a>
              &nbsp;
              <a id="ctgca" className="navbar-item">
                <Link to="/about" id="ctgc" className="navbar-item">About</Link>
              </a>
              &nbsp;
              <a id="ctgca" className="navbar-item">
                <Link to="/security" id="ctgc" className="navbar-item">Security</Link>
              </a>
              &nbsp;
              <a id="ctgca" className="navbar-item">
                <Link to="/contact" id="ctgc" className="navbar-item">Contact</Link>
              </a>
              &nbsp;
          </div>
        </div>
      </div>
     </div>
    </nav>
    </div>
    </section>
    <div><p>&nbsp; </p></div>
    <div class="clear"></div>
    </div>
   );
  }
}

Nav.propTypes = {
  siteTitle: PropTypes.string,
}

Nav.defaultProps = {
  siteTitle: ``,
}

export default Nav
